import { Button } from '@1trading/react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/lib/theme-provider';

export const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();

  return (
    <Button aria-label="Toggle theme" onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')} size="icon" variant="ghost">
      {theme === 'dark' ? <Sun className="size-4" /> : <Moon className="size-4" />}
    </Button>
  );
};
ThemeToggle.displayName = 'ThemeToggle';
